import angular from 'angular';
import forEach from 'lodash/forEach';
import isArray from 'lodash/isArray';

/**
 * Handles service class
 *
 * @author Marcin Kozłowski <m.kozlowski@iccomplex.eu>
 * @version 1.0
 */
class HandlesService {
    constructor(config, dataService) {
        this.initialData = [];
        this.config = config;
        this.dataService = dataService;
        this.handleColors = [];
        this.handleOptions = [];
        this.selectedHandleColor = null;
        this.selectedHandleOptions = [];
        this.allowMultipleOptions = false;
        this.handleSide = 'inside';
    }

    onInit() {
        this.dataService.data.data[0].relationships.handleOptions.data.forEach((value) => {
            if (value.id !== null) {
                this.setHandleOption(value.id);
            }
        });
    }

    isHandleOptionSelected(id) {
        if (isArray(this.selectedHandleOptions)) {
            return this.selectedHandleOptions.indexOf(id) !== -1;
        }
        return this.selectedHandleOptions == id;
    }

    isHandleColorSelected(id) {
        if (this.selectedHandleColor === null) {
            return false;
        }
        if (this.selectedHandleColor === id) {
            return true;
        }
        return false;
    }

    setHandleColor(id) {
        this.selectedHandleColor = id;
    }

    setHandleOption(id) {
        if (isArray(this.selectedHandleOptions)) {
            this.selectedHandleOptions.push(id);
        } else {
            this.selectedHandleOptions = id;
        }
    }

    removeHandleOption(id) {
        if (isArray(this.selectedHandleOptions)) {
            this.selectedHandleOptions.splice(this.selectedHandleOptions.indexOf(id), 1);
        } else {
            this.selectedHandleOptions = [];
        }
    }

    toggleHandleOption(id) {
        if (!this.isHandleOptionSelected(id)) {
            this.setHandleOption(id);
        } else {
            this.removeHandleOption(id);
        }
    }

    setHandleOptions() {
        if (
            angular.isDefined(this.dataService.data.included.handleOptions) &&
            this.dataService.data.included.handleOptions.length > 0
        ) {
            this.handleOptions = this.dataService.data.included.handleOptions;
        }
        return this.handleOptions;
    }

    showUniversalKey() {
        if (
            angular.isUndefined(this.dataService.data.included.handleOptions) ||
            this.dataService.data.included.handleOptions.length < 1
        ) {
            return true;
        }
        this.dataService.data.included.handleOptions.forEach((option) => {
            if (option.attributes.accessoryType === '20') {
                option.attributes.isHidden = false;
            }
        });
    }

    setHandleColors(data) {
        this.handleColors = data;
    }

    getHandleOptions() {
        return this.handleOptions;
    }

    getHandleColors() {
        return this.handleColors;
    }

    getHandle(id) {
        let handle = false;

        if (angular.isUndefined(this.dataService.data.included.handle)) {
            return handle;
        }
        forEach(this.dataService.data.included.handle, (element) => {
            if (element.id === id) {
                handle = element;
                return handle;
            }
        });
        return handle;
    }

    hasMultipleHandleColorChoices() {
        if (this.getHandleColors().length > 0) {
            return true;
        }
        return false;
    }

    hasHandleOptions() {
        if (this.getHandleOptions().length > 0) {
            return true;
        }
        return false;
    }

}

HandlesService.$inject = ['config', 'dataService'];

export default angular.module('handlesService', [])
    .service('handlesService', HandlesService)
    .name;